// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; 
import AfterSchoolProgramsBody from '../../components/internal/SegueK-8/AfterSchoolPrograms/AfterSchoolProgramsBody';

function AfterSchoolPrograms() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <AfterSchoolProgramsBody />
      <Footer />
    </>
  );
}

export default AfterSchoolPrograms;